var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlusSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.23858 0 0 2.23858 0 5V35C0 37.7614 2.23858 40 5 40H35C37.7614 40 40 37.7614 40 35V5C40 2.23858 37.7614 0 35 0H5ZM21.25 11.25V18.75H28.75C29.4404 18.75 30 19.3096 30 20C30 20.6904 29.4404 21.25 28.75 21.25H21.25V28.75C21.25 29.4404 20.6904 30 20 30C19.3096 30 18.75 29.4404 18.75 28.75V21.25H11.25C10.5596 21.25 10 20.6904 10 20C10 19.3096 10.5596 18.75 11.25 18.75H18.75V11.25C18.75 10.5596 19.3096 10 20 10C20.6904 10 21.25 10.5596 21.25 11.25Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlusSquare);
export default __webpack_public_path__ + "static/media/ico-plus-square.b8b94695c1215c669a48288ab0efd748.svg";
export { ForwardRef as ReactComponent };